import React from "react";
import { Link } from "react-router-dom";
import { Home, Search, Shield, Zap, BarChart } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0f0f0f] text-white flex flex-col">

      <div className="flex justify-between items-center px-6 py-4 border-b border-white/10">
        <img
          src="https://cdn.prod.website-files.com/638fda8f8e2f041af84cb5a7/6824d581ae24f69d45e26536_beem%20logo%203.png"
          alt="Beem logo"
          className="w-24"
        />
        <div className="text-sm text-gray-400 flex items-center gap-2">
          <Shield size={14}/> Still secure. Just lost.
        </div>
      </div>

      <div className="flex flex-1 items-center justify-center px-6 py-12">
        <div className="max-w-xl text-center">

          <div className="flex justify-center mb-6">
            <div className="bg-white/5 border border-white/10 p-6 rounded-2xl">
              <Search size={40} className="text-[#AF9B8A]" />
            </div>
          </div>

          <h1 className="text-5xl font-bold mb-4">
            This page doesn’t exist
          </h1>

          <p className="text-gray-400 text-lg mb-6">
            Either the link is broken, or you’ve wandered off the path. Happens to the best of us.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">



            <Link
              to="/"
              className="flex items-center justify-center gap-2 border border-white/10 hover:bg-white/5 px-6 py-3 rounded-lg transition"
            >
              <Home size={16}/> Go home
            </Link>

          </div>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 text-left">
            <p className="text-sm text-gray-400 mb-4">
              While you’re here, here’s what you’re missing:
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm text-gray-300">
              <div className="flex items-center gap-2">
                <Zap size={14}/> Faster workflows
              </div>
              <div className="flex items-center gap-2">
                <BarChart size={14}/> Real-time insights
              </div>
              <div className="flex items-center gap-2">
                <Shield size={14}/> Secure & compliant
              </div>
            </div>

            <p className="text-xs text-gray-500 mt-4">
              Join early. First 500 users still get 3 months free.
            </p>
          </div>

        </div>
      </div>

      <div className="text-center text-xs text-gray-500 py-6 border-t border-white/10">
        © {new Date().getFullYear()} Beem • Built for modern landlords
      </div>

    </div>
  );
}
